@let f = form();
<div class="mb-16 mt-40 h-1 w-full bg-grey-300"></div>
<h2 class="leading-22 mb-6 text-16 lg:text-20 lg:leading-25">Ihre Daten</h2>
<div class="grid grid-cols-1 gap-x-[50px] gap-y-16 lg:grid-cols-2">
    <div>
        @let nameCtr = f.controls.name;
        <ui-input-text
            [formControl]="nameCtr"
            [error]="nameCtr.touched && nameCtr.invalid"
            [errorMsg]="getErrorMessage(nameCtr, errorMsg())"
            (click)="formClicked.emit()"
            label="Name"
        />
    </div>
    <div>
        @let emailCtr = f.controls.email;
        <ui-input-text
            [formControl]="emailCtr"
            [error]="emailCtr.touched && emailCtr.invalid"
            [errorMsg]="getErrorMessage(emailCtr, errorMsg())"
            (click)="formClicked.emit()"
            label="Email-Adresse"
            type="email"
        />
    </div>
    <div>
        @let phoneCtr = f.controls.phoneNumber;
        <ui-input-text
            [formControl]="phoneCtr"
            [error]="phoneCtr.touched && phoneCtr.invalid"
            [errorMsg]="getErrorMessage(phoneCtr, errorMsg())"
            (click)="formClicked.emit()"
            label="Telefonnummer (optional)"
        />
    </div>
</div>
<div
    class="frc-captcha"
    #frccaptcha
    data-sitekey="FCMGC0V4K1N4MFFN"
    data-puzzle-endpoint="https://api.friendlycaptcha.com/api/v1/puzzle"
></div>
<div class="mt-16 text-14">
    <!-- <ui-input-checkbox [formControl]="f.controls.tradeIn">Fahrzeug in Zahlung geben</ui-input-checkbox> -->
    <p class="mb-8 font-medium">Datenschutzhinweis bzgl. Ihrer Anfrage</p>
    <p class="leading-21 mb-24 text-grey-400">
        Wenn Sie uns per Kontaktformular eine Anfrage übermitteln, werden Ihre Angaben inkl. Ihrer Kontaktdaten für die
        Bearbeitung Ihrer Anfrage durch die Hyundai Motor Deutschland GmbH und den ausführenden Vertragshändler sowie
        ggf. weitere eingesetzte Dienstleister gespeichert und verarbeitet. Die Datenverarbeitung erfolgt auf Grundlage
        unseres berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO) und zur Durchführung vorvertraglicher Maßnahmen
        (Art. 6 Abs. 1 lit. b DSGVO). Weitere Informationen finden Sie in unseren
        <a class="font-bold underline" hyundaiRouterLink="https://www.hyundai.com/de/de/datenschutz.html">
            Datenschutzhinweisen.
        </a>
    </p>
    <p class="mb-12 font-medium">Einwilligungserklärung personalisiertes Marketing</p>
    <div class="flex">
        <ui-input-checkbox [formControl]="f.controls.privacyNotice" />
        <div>
            <p>
                Ich bin damit einverstanden, dass die von mir angegebenen personenbezogenen Kontaktdaten, unter
                Verwendung meiner E-Mail-Adresse, meiner Telefonnummer (auch für den Versand von
                SMS/Instant-Messenger-Nachrichten) und meiner postalischen Adresse dem ausgewählten Hyundai
                Vertragshändler zur
                <span class="font-bold">
                    Durchführung von Marketingmaßnahmen, einschließlich dem Versand von Direktwerbung für Produkte und
                    Dienstleistungen
                </span>
                verarbeitet werden dürfen.
            </p>
            <br />
            <p>
                Ihre Einwilligung können Sie jederzeit gegenüber dem ausgewählten Händler z.B. per E-Mail oder
                postalisch versandten Brief widerrufen.
            </p>
        </div>
    </div>

    <!-- <p class="leading-21 text-grey-400">
        Ich erkläre mich damit einverstanden, dass meine persönlichen Daten für Marketing- und Kommunikationszwecke,
        via:
    </p>
    <div class="flex gap-40">
        <ui-input-checkbox [formControl]="f.controls.marketingEmail">Email</ui-input-checkbox>
        <ui-input-checkbox [formControl]="f.controls.marketingPhone">Telefon</ui-input-checkbox>
        <ui-input-checkbox [formControl]="f.controls.marketingSms">SMS</ui-input-checkbox>
    </div>
    <p class="leading-21 text-grey-400">
        verwendet werden. Durch Absenden Ihrer Informationen bestätigen Sie, dass Sie unsere Datenschutzrichtlinie
        gelesen haben und sich damit einverstanden erklären. Diese Einwilligung kann jederzeit widerrufen werden, z.B.
        über den Link zur Abmeldung im Newsletter. (Optional)
    </p> -->
</div>
<div class="my-32 grid grid-cols-1 gap-x-[50px] gap-y-16 lg:grid-cols-2">
    <div class="hidden lg:block"></div>
    <button class="button-primary" [disabled]="form().invalid" (click)="submitClicked.emit()">Absenden</button>
</div>
